import { useEffect, useState } from 'react';

import { type AiGenerateDockOnboardingRect } from '../utils/aiGenerateDockOnboarding';

const toRect = (element: HTMLElement): AiGenerateDockOnboardingRect => {
  const { top, left, width, height } = element.getBoundingClientRect();
  return { top, left, width, height };
};

const isSameRect = (
  a: AiGenerateDockOnboardingRect | null,
  b: AiGenerateDockOnboardingRect,
) =>
  a !== null &&
  a.top === b.top &&
  a.left === b.left &&
  a.width === b.width &&
  a.height === b.height;

/**
 * 강조 대상의 화면 위치 — dim 구멍을 그 자리에 뚫는다. 카드 위치는 Radix Popover 가 따로 따라가지만
 * 구멍은 Radix 밖이라 직접 잰다. 대상 크기(글이 늘어 입력칸이 커짐)·창 크기·스크롤이 바뀔 때 다시 잰다.
 */
export const useAiGenerateDockOnboardingTargetRect = (
  target: HTMLElement | null,
) => {
  const [rect, setRect] = useState<AiGenerateDockOnboardingRect | null>(null);

  useEffect(() => {
    if (!target) {
      setRect(null);
      return;
    }
    const measure = () => {
      const next = toRect(target);
      setRect(prev => (isSameRect(prev, next) ? prev : next));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(target);
    window.addEventListener('resize', measure);
    // 스크롤은 어느 조상에서 일어나도 잡도록 capture 로 듣는다.
    window.addEventListener('scroll', measure, true);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [target]);

  return rect;
};
